"use strict";

var _regeneratorRuntime = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/data/trilogy-group/totogi-developer-portal/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistryApi = void 0;

var node_fetch_1 = require("node-fetch");

var version = require('../../package.json').version;

var RegistryApi = /*#__PURE__*/function () {
  function RegistryApi(accessToken) {
    _classCallCheck(this, RegistryApi);

    this.accessToken = accessToken;
    this.baseUrl = "https://api.".concat(process.env.REDOCLY_DOMAIN || 'redoc.ly', "/registry");
  }

  _createClass(RegistryApi, [{
    key: "request",
    value: function request() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var headers, response, body;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.accessToken) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Unauthorized');

              case 2:
                headers = Object.assign({}, options.headers || {}, {
                  authorization: this.accessToken,
                  'x-redocly-cli-version': version
                });
                _context.next = 5;
                return node_fetch_1.default("".concat(this.baseUrl).concat(path), Object.assign({}, options, {
                  headers: headers
                }));

              case 5:
                response = _context.sent;

                if (!(response.status === 401)) {
                  _context.next = 8;
                  break;
                }

                throw new Error('Unauthorized');

              case 8:
                if (!(response.status === 404)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 11;
                return response.json();

              case 11:
                body = _context.sent;
                throw new Error(body.code);

              case 13:
                return _context.abrupt("return", response);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setAccessToken",
    value: function setAccessToken(accessToken) {
      this.accessToken = accessToken;
      return this;
    }
  }, {
    key: "authStatus",
    value: function authStatus() {
      var verbose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.request();

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.ok);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                if (verbose) {
                  console.log(_context2.t0);
                }

                return _context2.abrupt("return", false);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));
    }
  }, {
    key: "prepareFileUpload",
    value: function prepareFileUpload(_ref) {
      var organizationId = _ref.organizationId,
          name = _ref.name,
          version = _ref.version,
          filesHash = _ref.filesHash,
          filename = _ref.filename,
          isUpsert = _ref.isUpsert;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.request("/".concat(organizationId, "/").concat(name, "/").concat(version, "/prepare-file-upload"), {
                  method: 'POST',
                  headers: {
                    'content-type': 'application/json'
                  },
                  body: JSON.stringify({
                    filesHash: filesHash,
                    filename: filename,
                    isUpsert: isUpsert
                  })
                });

              case 2:
                response = _context3.sent;

                if (!response.ok) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", response.json());

              case 5:
                throw new Error('Could not prepare file upload');

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "pushApi",
    value: function pushApi(_ref2) {
      var organizationId = _ref2.organizationId,
          name = _ref2.name,
          version = _ref2.version,
          rootFilePath = _ref2.rootFilePath,
          filePaths = _ref2.filePaths,
          branch = _ref2.branch,
          isUpsert = _ref2.isUpsert;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.request("/".concat(organizationId, "/").concat(name, "/").concat(version), {
                  method: 'PUT',
                  headers: {
                    'content-type': 'application/json'
                  },
                  body: JSON.stringify({
                    rootFilePath: rootFilePath,
                    filePaths: filePaths,
                    branch: branch,
                    isUpsert: isUpsert
                  })
                });

              case 2:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                throw new Error('Could not push api');

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return RegistryApi;
}();

exports.RegistryApi = RegistryApi;